module.exports = __webpack_public_path__ + "img/chistory_banner.45999d13.jpg";